<template>
  <div class="page" :style="{ minHeight: pageHeight + 'px' }">
    <img class="head" src="./assets/img/lipei.png" alt="" />
    <img class="container" src="./assets/img/lipei2.png" alt="" />
    <!-- <div class="liucheng">
      <div class="item">
        <div class="left">
          <div class="icon"></div>
          <div class="qiu" style="top: 0.05rem;"></div>
        </div>
        <div class="right">
          <div class="title">医院就诊</div>
          <div class="tip">第一时间去二级及二级以上公立医院就诊</div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon"></div>
          <div class="qiu" style="top: 0.05rem;"></div>
        </div>
        <div class="right">
          <div class="title">电话报案</div>
          <div class="tip">
            拨打4008933988或希望保理赔专线13075582752进行报案
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon"></div>
          <div class="qiu" style="top: 0.05rem;"></div>
        </div>
        <div class="right">
          <div class="title">提交材料</div>
          <div class="tip">
            治疗结束联系希望保理赔专员，根据指引递交理赔材料
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left" style="border-right: 0">
          <div class="icon"></div>
          <div class="qiu" style="top: 0.05rem;"></div>
        </div>
        <div class="right">
          <div class="title">获得赔款</div>
          <div class="tip">审核无误后转交保险公司复核并支付赔款</div>
        </div>
      </div>

      <div class="line"></div>
    </div> -->
    <div class="customer">
      <div class="left">
        <img src="./assets/img/WechatIMG268.png" alt="" />
      </div>
      <div class="right">
        <div class="title">添加客服微信联系我们</div>
        <div class="tip">
          客服电话： <a href="tel:4008933988">4008933988</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Claim",
  components: {},
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
    };
  },
  watch: {},
  mounted() {},
  beforeDestroy: function () {},
  methods: {
    callPhone() {
      wx.makePhoneCall({
        phoneNumber: "1340000", //仅为示例，并非真实的电话号码
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  //   padding: 0.15rem;
  box-sizing: border-box;
  background: #e7fcee;
  display: flex;
  flex-direction: column;
  .head {
    width: 100%;
  }
  .container {
    width: 100%;
  }
  .liucheng {
    width: 3.45rem;
    height: 4.09rem;
    background: #ffffff;
    border-radius: 0.1rem;
    padding: 0.3rem 0.16rem;
    box-sizing: border-box;
    position: relative;
    .line {
      position: absolute;
      left: 0.66rem;
      width: 1px;
      border-right: 2px dashed rgba(23, 142, 102, 0.35);
      height: 2.7rem;
      top: 0.46rem;
    }
    .item {
      display: flex;
      position: relative;
      .left {
        padding-right: 0.09rem;
        // border-right:2px dashed rgba(23, 142, 102, .35);
        position: relative;
        .icon {
          width: 0.41rem;
          height: 0.41rem;
          border: 1px solid #319a77;
          opacity: 0.35;
          border-radius: 50%;
        }
        .qiu {
          width: 0.08rem;
          height: 0.08rem;
          background: #178e66;
          border-radius: 50%;
          position: absolute;
          right: -0.04rem;
          top: 0;
        }
      }
      .right {
        padding-left: 0.09rem;
        box-sizing: border-box;
        .title {
          font-size: 0.18rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #333333;
        }
        .tip {
          font-size: 0.14rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #888888;
          margin-top: 0.1rem;
          margin-bottom: 0.37rem;
          line-height: 0.18rem;
        }
      }
    }
  }
  .customer {
    display: flex;
    justify-content: center;
    padding: 0.2rem 0;
    .left {
      height: 0.8rem;
      img {
        width: 0.8rem;
        height: 0.8rem;
        background: #ffffff;
        border-radius: 0rem;
        margin-bottom: 0.8rem;
      }
    }
    .right {
      margin-left: 0.26rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title {
        font-size: 0.18rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #333333;
      }
      .tip {
        font-size: 0.12rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #333333;
        margin-top: 0.14rem;
      }
    }
  }
}
</style>
